import {useCallback} from 'react';
import addStudyProgressDoc from '../../api/progress/addStudyProgressDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useAddStudyProgress() {
  const addStudyProgress = useCallback(
    async (examModuleId: string, topic: string, done?: boolean, titles?: string[], progress?: number) => {
      const uid = firebaseAuth.currentUser?.uid;
      if (!uid) {
        throw new Error('Not authenticated');
      }

      await addStudyProgressDoc(uid, {
        examModuleId,
        topic,
        titles,
        done,
        progress,
      });
    },
    [],
  );

  const {loading, error, refetch} = useFunctionRun(addStudyProgress, {
    skipLoadOnMount: true,
  });

  return {addStudyProgress: refetch, loading, error};
}
